
export const IconEraser = ({style, className}) => {
    // style={style}
    return (
        <svg style={style} className={className} viewBox="0 0 24 24" fill="none" xmlns="http://www.w3.org/2000/svg">
            <path d="M9 22H21" strokeWidth="1.5" strokeLinecap="round" strokeLinejoin="round"/>
            <path d="M2.90875 17.58L6.41876 21.09C7.58876 22.26 9.49875 22.26 10.6587 21.09L21.0888 10.66C22.2588 9.48997 22.2588 7.57997 21.0888 6.41997L17.5788 2.90997C16.4088 1.73997 14.4988 1.73997 13.3388 2.90997L2.90875 13.34C1.73875 14.5 1.73875 16.41 2.90875 17.58Z"
             strokeWidth="1.5" 
             strokeLinecap="round" 
             strokeLinejoin="round"/>
            <path d="M7.12109 9.13L14.8711 16.88" strokeWidth="1.5" strokeLinecap="round" strokeLinejoin="round"/>
            <path d="M3.51953 17.66L9.16949 12" strokeWidth="1.5" strokeLinecap="round" strokeLinejoin="round"/>
            <path d="M6.33984 20.49L11.9998 14.83" strokeWidth="1.5" strokeLinecap="round" strokeLinejoin="round"/>
        </svg>
    )
}